import { patchRequest } from '@/core';
import { deviations } from '@/requests';

export default async function updateTripRequest(id, patch) {
	let url = deviations.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
